module.exports = __webpack_public_path__ + "static/media/supply-chain-icon.7fc40808.svg";